import script from "./DesktopDownloadButton.vue?vue&type=script&setup=true&lang=js"
export * from "./DesktopDownloadButton.vue?vue&type=script&setup=true&lang=js"

import "./DesktopDownloadButton.vue?vue&type=style&index=0&id=051afd14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-051afd14"]])

export default __exports__